<template>

  <ancestryline-modal title="protocol.forward"  id="protocol-forward-modal" :close="true" @close="close" :loading="false">

    <card>
      <coff-input-select v-model="userToForward" label="protocol.user" class="p-col-12 p-md-6 p-lg-4" :options="users" />
    </card>

    <template #footer>
      <Button class="p-mr-2" @click="close()">{{$t('btn.cancel')}}</Button>
      <div class="p-ml-auto">
        <Button :label="$t('protocol.forward-to-me')" @click="forwardToMe"/>
        <Button :label="$t('btn.save')" @click="forward" class="p-ml-2 p-button-success"/>
      </div>
    </template>

  </ancestryline-modal>

</template>

<script>
import DialogService from "@/business/ModalBusiness";
import UserBusiness from "@/business/UserBusiness";
import AuthBusiness from "@/business/AuthBusiness";
import ProtocolBusiness from "@/business/ProtocolBusiness";

export default {
  name: "ModalForwardProtocol",

  props: {
    protocol: {type: Object, default: ()=>{return{}}}
  },

  data(){
    return {
      userToForward: null,
      users: [],
    }
  },

  async mounted() {
    this.users = await UserBusiness.getAll();
  },

  methods: {

    close(){
      DialogService.closeModal();
    },

    async forwardToMe(){
      const currentUser = await AuthBusiness.getLoggedUser();
      await this.save(currentUser);
    },

    async forward(){
      await this.save(this.userToForward)
    },

    async save(user){
      const response = await ProtocolBusiness.forward(this.protocol.id, user);
      if(response){
        DialogService.closeModal(user);
      }
    }

  }

}
</script>

<style scoped>

</style>